/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// 招标书市场列表
exports.getCallBidDocMarketList = function (params, callback) {// 获取招标书市场列表
    api.post('/callBid/doc/market/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 定向招标书市场列表
exports.getCallBidDocAppointList = function (params, callback) {// 获取定向招标书列表
    api.post('/callBid/doc/appoint/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取招标书信息
exports.getCallBidDocInfo = function (params, callback) {// 获取招标书详细信息
    api.post('/callBid/doc/info/get')
    .data(params)
    .done(callback)
    .go();
};

// 招标商务条款
exports.getCallBidTermList = function (params, callback) {// 查询招标条款列表
    api.post('/callBid/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

//招标公告
exports.getCallBidNotice = function (params, callback) {// 查询招标公告
    api.get('/callBid/notice/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getCallBidNoticeListByDocId = function (params, callback) {// 根据docId查询招标公告列表
    api.get('/callBid/notice/get/by/docId')
    .params(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/callBid.js
// module id = 78
// module chunks = 1